'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:inject:loadHTML');
}

var _invoke = require('../invoke');

/**
 * 打开一个隐藏 webview
 *
 * 如果指定的 `name` 还不存在，会创建一个新的 webview。
 * 在指定的 webview 中加载给定的 `html` 片段
 * 在加载页面所有静态资源请求都完成时，Promise resolve。
 * 但是不保证页面已经可用，业务方可自己进行 domready 等检测。
 *
 * 支持版本
 * + iHotel/6.1+
 *
 * @memberof inject
 * @static
 * @name loadHTML
 * @param {String} name 隐藏 webview 名
 * @param {String} url 需要加载的页面地址
 * @param {String} html 需要加载的 html 片段
 * @return {Promise}
 * @example
 *  hbnb.inject.loadHTML(
 *      'name',
 *      'https://kyfw.12306.cn/otn/',
 *      '<!DOCTYPE html><html><head><meta charset="utf-8" /></head><body></body></html>'
 *  ).then(function() {
 *      console.log('loaded');
 *  });
 */
module.exports = function(name, url, html) {
    if (process.env.NODE_ENV !== 'production') {
        debug('name is %s', name);
        debug('url is %s', url);
        debug('html is %s', html);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('inject', 'load_html', {
            name: name,
            baseUrl: url,
            html: html,
            callback: function() {
                resolve();
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/inject/load-html.js
// module id = 591
// module chunks = 0